import { render, staticRenderFns } from "./articleDtl.vue?vue&type=template&id=6f884fd1&scoped=true&"
import script from "./articleDtl.vue?vue&type=script&lang=js&"
export * from "./articleDtl.vue?vue&type=script&lang=js&"
import style0 from "./articleDtl.vue?vue&type=style&index=0&id=6f884fd1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f884fd1",
  null
  
)

export default component.exports